export default __webpack_public_path__ + "static/media/h100-5.cdf902c1.png";